import { render, staticRenderFns } from "./RecaptureAIAudit.vue?vue&type=template&id=5c4d0a49&scoped=true&"
import script from "./RecaptureAIAudit.vue?vue&type=script&lang=ts&"
export * from "./RecaptureAIAudit.vue?vue&type=script&lang=ts&"
import style0 from "./RecaptureAIAudit.vue?vue&type=style&index=0&id=5c4d0a49&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c4d0a49",
  null
  
)

export default component.exports